export default {
  GET_DEALERS: (state) => state.dealers,
  GET_ACTIVE_DEALERS: (state) => state.dealers.filter((dealer) => dealer.status),
  GET_DEALER: (state) => state.dealer,
};
